import { useState, useRef } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import AboutUsBlock from "../../components/AboutUsBlock";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";

const mainColor = "#fff";
const menuFontColor = "rgb(46,24,106)";
const dropdownTextColor = "rgb(46,24,106)";
const dropdownHoverBg = "#f4f7fb";
const dropdownShadow = "0 8px 24px rgba(36, 45, 60, 0.14)";

const dropdownItems = [
  { id: "kursy", label: "Druk 3D" },
  { id: "kursy", label: "Start w AI" },

];

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisible] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpenMobile, setDropdownOpenMobile] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 200 });
  const buttonRef = useRef<HTMLDivElement>(null);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setVisible(false);
    setDropdownOpen(false);
    setDropdownOpenMobile(false);
  };

  const handleOpenDropdown = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPos({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: Math.max(200, rect.width),
      });
    }
    setDropdownOpen(true);
  };

  const MenuItem = () => (
    <>
      <CustomNavLinkSmall onClick={() => scrollTo("about")} style={{ color: menuFontColor }}>
        <Span>{t("About")}</Span>
      </CustomNavLinkSmall>

      <div style={{ position: "relative", display: "inline-block" }} onMouseEnter={handleOpenDropdown} onMouseLeave={() => setDropdownOpen(false)}>
        <CustomNavLinkSmall as="div" ref={buttonRef} style={{ cursor: "pointer", color: menuFontColor }}>
          <Span>{t("Mission")}</Span>
        </CustomNavLinkSmall>
        {dropdownOpen && (
          <div
            style={{
              position: "fixed",
              top: dropdownPos.top,
              left: dropdownPos.left,
              background: "#fff",
              boxShadow: dropdownShadow,
              borderRadius: "0 0 14px 14px",
              minWidth: dropdownPos.width,
              maxWidth: 320,
              zIndex: 10000,
              padding: "10px 0",
              border: "1px solid #f0f0f0",
              borderTop: "none",
              animation: "dropdown-in .2s cubic-bezier(.3,1.5,.5,1) both",
            }}
          >
            {dropdownItems.map((item, idx) => (
              <div
                key={idx}
                onClick={() => scrollTo(item.id)}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = dropdownHoverBg;
                  e.currentTarget.style.fontWeight = "700";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.fontWeight = "500";
                }}
                style={{
                  padding: "13px 30px",
                  cursor: "pointer",
                  color: dropdownTextColor,
                  fontWeight: 500,
                  borderTop: idx > 0 ? "1px solid #f0f0f0" : "none",
                  whiteSpace: "nowrap",
                }}
              >
                {item.label}
              </div>
            ))}
          </div>
        )}
      </div>
      

      <CustomNavLinkSmall onClick={() => scrollTo("product")} style={{ color: menuFontColor }}>
        <Span>{t("Product")}</Span>
      </CustomNavLinkSmall>

      <CustomNavLinkSmall onClick={() => scrollTo("contact")} style={{ color: menuFontColor }}>
        <Span>
          <Button>{t("Contact")}</Button>
        </Span>
      </CustomNavLinkSmall>
    </>
  );

  const MenuItemMobile = () => (
    <>
      <CustomNavLinkSmall onClick={() => scrollTo("about")} style={{ color: mainColor }}>
        <Span>{t("About")}</Span>
      </CustomNavLinkSmall>

      <CustomNavLinkSmall onClick={() => setDropdownOpenMobile(!dropdownOpenMobile)} style={{ color: mainColor, background: dropdownOpenMobile ? dropdownHoverBg : "transparent" }}>
        <Span>
          {t("Mission")} <span>{dropdownOpenMobile ? "▲" : "▼"}</span>
        </Span>
      </CustomNavLinkSmall>

      {dropdownOpenMobile &&
        dropdownItems.map((item, idx) => (
          <div
            key={idx}
            onClick={() => scrollTo(item.id)}
            onMouseOver={(e) => {
              e.currentTarget.style.background = dropdownHoverBg;
              e.currentTarget.style.fontWeight = "700";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = "#fff";
              e.currentTarget.style.fontWeight = "500";
            }}
            style={{
              padding: "0.5rem 2rem",
              color: dropdownTextColor,
              background: "#fff",
              fontWeight: 500,
              fontSize: "1rem",
            }}
          >
            {item.label}
          </div>
        ))}

      <CustomNavLinkSmall onClick={() => scrollTo("product")} style={{ color: mainColor }}>
        <Span>{t("Product")}</Span>
      </CustomNavLinkSmall>

      <CustomNavLinkSmall onClick={() => scrollTo("contact")} style={{ color: mainColor }}>
        <Span>
          <Button>{t("Contact")}</Button>
        </Span>
      </CustomNavLinkSmall>

      <AboutUsBlock />
    </>
  );

  return (
    <HeaderSection style={{ background: mainColor, minHeight: 68 }}>
      <Container>
        <Row justify="space-between" align="middle" wrap={false}>
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon src="logo.svg" width="100%" height="1000%" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={() => setVisible(!visible)}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={() => setVisible(false)} bodyStyle={{ paddingTop: 0 }}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={() => setVisible(false)}>
              <Col span={12}><Menu>Menu</Menu></Col>
              <Col span={12}><Outline /></Col>
            </Label>
          </Col>
          <MenuItemMobile />
        </Drawer>
      </Container>
      <style>{`
        @keyframes dropdown-in {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
